import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Privacy from "./pages/Privacy";
import DataDeletion from "./pages/DataDeletion";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import { Loading } from "@/components/common";
import AuthPage from "@/pages/AuthPage";
import Overview from "@/pages/Overview";
import Accounts from "@/pages/Accounts";
import PhoneNumbers from "@/pages/PhoneNumbers";
import Inbox from "@/pages/Inbox";
import Contacts from "@/pages/Contacts";
import Chatbot from "@/pages/Chatbot";
import Templates from "@/pages/Templates";
import Campaigns from "@/pages/Campaigns";
import Playground from "@/pages/Playground";
import ApiKeys from "@/pages/ApiKeys";
import Webhooks from "@/pages/Webhooks";
import Analytics from "@/pages/Analytics";
import Team from "@/pages/Team";
import SettingsPage from "@/pages/Settings";

function Protected({ children }) {
  const { session } = useAuth();
  if (session === null) return <Loading label="Checking session" />;
  if (!session) return <Navigate to="/login" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { session } = useAuth();
  if (session === null) return <Loading />;
  return session ? <Navigate to="/" replace /> : children;
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<PublicOnly><AuthPage mode="login" /></PublicOnly>} />
            <Route path="/register" element={<PublicOnly><AuthPage mode="register" /></PublicOnly>} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/data-deletion" element={<DataDeletion />} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route index element={<Overview />} />
              <Route path="whatsapp-accounts" element={<Accounts />} />
              <Route path="phone-numbers" element={<PhoneNumbers />} />
              <Route path="inbox" element={<Inbox />} />
              <Route path="contacts" element={<Contacts />} />
              <Route path="chatbot" element={<Chatbot />} />
              <Route path="templates" element={<Templates />} />
              <Route path="campaigns" element={<Campaigns />} />
              <Route path="playground" element={<Playground />} />
              <Route path="api-keys" element={<ApiKeys />} />
              <Route path="webhooks" element={<Webhooks />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="team" element={<Team />} />
              <Route path="settings" element={<SettingsPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}
